import { isChoiceProductRoot, isHeaderLine } from "@/infrastructure/data-functions";
import { addTargetBlankToAnchors } from "@/infrastructure/utilities";
import defaultPreviewImg from "@/assets/images/no-preview.png";
import { formatCurrency } from "@/infrastructure/utilities";
import { computed, ref } from "vue";
import ProductCheckbox from "./ProductCheckbox";
import ProductDropdown from "./ProductDropdown";
import ProductImageModal from "@/components/product/ImageModal.js";
import { isProductSet } from "../../infrastructure/data-functions";

export default {
  components: { ProductCheckbox, ProductDropdown, ProductImageModal },
  props: {
    productNode: {
      type: Object,
      required: true,
    },
    quantity: {
      type: Number,
      required: true,
    },
    quantityEnabled: {
      type: Boolean,
      default: false,
    },
    selectedIds: {
      type: Array,
      default: () => [],
    },
    isOrdered: {
      type: Boolean,
      required: true,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["add-product", "remove-product", "toggle-product", "popup-product"],
  setup(props, { emit }) {
    const product = computed(() => props.productNode.value);
    return {
      collapseDescription: ref(false),

      product,
      productPreviewImg: computed(() => (product.value.image && product.value.image.source) || defaultPreviewImg),
      productHtmlDescription: computed(() => addTargetBlankToAnchors(product.value.description).replace(/\r\n|\n/g, '<br />')),

      isHeaderLine: computed(() => isHeaderLine(props.productNode)),
      costPerUnitWithVat: computed(() => {
        if (isChoiceProductRoot(props.productNode)) {
          // price can differ between siblings (ToDo: multiple selected children)
          const orderedChild = props.productNode.getOffspring().find((o) => props.selectedIds.includes(o.value.id));
          if (orderedChild) {
            return formatCurrency(orderedChild.value.costPerUnitWithVat);
          }
        }
        return formatCurrency(product.value.costPerUnitWithVat);
      }),
      handleSetQuantity: (e) => {
        const quantity = parseFloat(e.target.value);
        if (quantity > 0) {
          emit("add-product", { productNode: props.productNode, quantity });
        } else {
          emit("remove-product", props.productNode);
        }
      },
      toggleProduct: (productId) => emit("toggle-product", productId),
      popupProduct: (product) => emit("popup-product", product),

      ProductControl: computed(() =>
        !props.productNode.value.disablePartsSelection && props.productNode.children.length > 0 ? ProductDropdown : ProductCheckbox
      ),
      isProductSet: computed(() => isProductSet(props.productNode)),
      productSetItemsSummary: computed(() => {
        const titles = props.productNode.getOffspring().map((n) => n.value.title);
        if (titles.length <= 1) {
          return titles.join("");
        }
        return [titles.slice(0, titles.length - 1).join(", "), titles.slice(-1)[0]].join(" en ");
      }),
    };
  },
};
